// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-tooltip__popper.tooltip-item{max-width:800px}.el-tooltip__popper.tooltip-item div{max-height:68px;overflow:hidden;overflow-y:scroll;scrollbar-width:none}.more-flag-box .content p{font-weight:400;color:#666;line-height:20px;margin-bottom:8px}.more-flag-box .content p:last-of-type{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
